import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Contract } from '../../models/contract';
import { ActivatedRoute } from '@angular/router';
import { BidsDashboard, Tender } from '../../models';

@Component({
    selector: 'jft-contract-dashboard',
    templateUrl: './contract-dashboard.component.html',
    styleUrls: ['./contract-dashboard.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ContractDashboardComponent implements OnInit {

    public tender: Tender;
    public contract: Contract;
    public suppliers: BidsDashboard[] = [];

    constructor(
        private route: ActivatedRoute
    ) {
    }

    public ngOnInit() {
        let data = this.route.snapshot.data,
            parentData = this.route.parent.snapshot.data,
            parentParentData = this.route.parent.parent.snapshot.data;

        this.tender = parentParentData['tender'];
        this.contract = data['contract'];
        this.suppliers = data['suppliers'];
    }

}
